const breakfast = [
    {
        id: 1,
        name: 'Kebabu : ケバブ',
        description: 'A plate with beef patty, tomato, mushrooms, black pudding, baked beans, and eggs',
        price: '¥500'
    },
    {
        id: 2,
        name: 'Chicken Shawama : チキンシャワルマ',
        description: 'Served with poached egg, avocado, onion, tomato, and bread.',
        price: '¥600'
    },
    {
        id: 3,
        name: 'Green Salad : グリーンサラダ',
        description: 'a refreshing salad made with fresh vegetables',
        price: '¥400'
    },
    {
        id: 4,
        name: 'Chana Salad : チャナサラダ',
        description: 'A spicy and refreshing salad made with chickpeas, onion, and tomato',
        price: '¥500'
    },
    {
        id: 5,
        name: 'Plane Nan : プレーンナン',
        description: 'Soft, fluffy Indian bread baked in a tandoor',
        price: '¥250'
    },
    {
        id: 6,
        name: 'Cheese Nan : チーズナン',
        description: 'Fluffy naan filled with melting cheese, baked in a tandoor',
        price: '¥500'
    },
    {
        id: 7,
        name: 'Roti : ロティ',
        description: 'A healthy South Asian bread made from whole wheat flour.',
        price: '¥250'
    },
    {
        id: 8,
        name: 'Vegetagle Samosa : ベジタブルサモサ',
        description: 'A triangular pastry filled with spiced vegetables and deep-fried',
        price: '2 pcs ¥500'
    },
    {
        id: 9,
        name: 'Chicken Salad : チキンサラダ',
        description: 'A healthy salad with grilled chicken and fresh vegetables',
        price: '¥500'
    },
    {
        id: 10,
        name: 'Fried Potato : フライドポテト',
        description: 'Crispy fried potatoes served hot',
        price: '¥400'
    },
    {
        id: 11,
        name: 'Butter Nan : バターナン',
        description: 'Soft tandoor-baked naan with a rich buttery flavor',
        price: '¥350'
    },
    {
        id: 12,
        name: 'Garlic Nan : ガーリックナン',
        description: 'Nan topped with fragrant garlic and baked in a tandoor',
        price: '¥500'
    },
    {
        id: 13,
        name: 'Rice : ライス',
        description: 'Fragrant basmati rice cooked to perfection',
        price: '¥250'
    }
];

export default breakfast;